import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import axios from "axios";
import { useContext, useState, useEffect } from "react";
import { UserContext } from "../../../service/context";

const Logs = ({ openTab, jobId, company_id, email }) => {
  const ctx = useContext(UserContext);
  const [token, setToken] = useState("");
  const [tabname, setTabName] = useState("JobDetails");
  useEffect(() => {
    if (openTab === 3) {
      //getEmbedUrl();
      getAccessToken();
    }
  }, [openTab]);
  const getEmbedUrl = () => {
    let groupId = "cdb42060-6814-47f3-aac7-f0ca6962934c";
    axios
      .get(`https://api.powerbi.com/v1.0/myorg/groups/${groupId}/reports`, {})
      .then((res) => {
        setToken(res.data.data.access_token);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getAccessToken = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/reporting/getAccessToken`, {
        headers: { Authorization: `Bearer ${ctx.user.token}` },
      })
      .then((res) => {
        setToken(res.data.data.access_token);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  return (
    <div
      id="tabAdded"
      className={openTab === 3 ? "mt-4 sm:mx-6 lg:mx-8" : "hidden"}
    >
      <PowerBIEmbed
        embedConfig={{
          type: "report", // Supported types: report, dashboard, tile, visual and qna
          id: `${process.env.REACT_APP_FIRST_REPORT_ID}`,
          embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${process.env.REACT_APP_FIRST_REPORT_ID}&groupId=${process.env.REACT_APP_GROUP_ID}&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d`,
          accessToken: token,
          tokenType: models.TokenType.Aad,
          settings: {
            background: models.BackgroundType.Transparent,
          },
          filters: [
            tabname === "JobDetails"
              ? ({
                  $schema: "http://powerbi.com/product/schema#basic",
                  target: {
                    table: "JobStatus",
                    column: "company_id",
                  },
                  operator: "In",
                  values: [company_id],
                },
                {
                  $schema: "http://powerbi.com/product/schema#basic",
                  target: {
                    table: "JobStatus",
                    column: "job_id",
                  },
                  operator: "IN",
                  values: [jobId],
                })
              : ({
                  $schema: "http://powerbi.com/product/schema#basic",
                  target: {
                    table: "UserDetails",
                    column: "company_id",
                  },
                  operator: "In",
                  values: [company_id],
                },
                {
                  $schema: "http://powerbi.com/product/schema#basic",
                  target: {
                    table: "UserDetails",
                    column: "UEmail",
                  },
                  operator: "In",
                  values: [email],
                }),
          ],
        }}
        eventHandlers={
          new Map([
            [
              "loaded",
              function () {
                console.log("Report loaded");
              },
            ],
            [
              "rendered",
              function () {
                console.log("Report rendered");
              },
            ],
            [
              "pageChanged",
              function (event) {
                setTabName(event.detail.newPage.displayName);
              },
            ],
            [
              "error",
              function (event) {
                console.log(event.detail);
              },
            ],
          ])
        }
        cssClassName={"report-style-class h-screen"}
        getEmbeddedComponent={(embeddedReport) => {
          window.report = embeddedReport;
        }}
      />
    </div>
  );
};

export default Logs;
